import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up-right"} maskId="square-filled-radius-0-stroke-1-IconArrowUpRight"><path fillRule="evenodd" clipRule="evenodd" d="M8.00015 5H19.0002V16H17.0002V8.41421L6.25015 19.1642L4.83594 17.75L15.5859 7H8.00015V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUpRight;
